import { authReducer } from "./authReducer";
import { snackReducer } from "./snackReducer";
import { locationReducer } from "./locationReducer";
import { ewtReducer } from "./ewtReducer";
import { combineReducers } from "redux";
import { graphInfoReducer } from "./graphInfoReducer";
import { FromInfoReducer } from "./FromInfoReducer";
import { workflowReducer } from "./workflowReducer";
import { BreReducer } from "./BreReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  snack: snackReducer,
  location: locationReducer,
  ewt: ewtReducer,
  graphInfo:graphInfoReducer,
  FormInfo: FromInfoReducer,
  workflow:workflowReducer,
  Bre:BreReducer

});

export default rootReducer;
